import { Alerts } from '../..';
import { svrtsRequest } from '../../svrts-interface';
export const generateMissingContent = (rs, notes) => {
    rs.updateState({ loadingCoverMessage: 'Generating...' });
    svrtsRequest({
        data: {
            funcID: [0, 62],
            notes: notes.map(note => ({
                id: note.ID,
                title: note.Title,
                note: note.Note,
                attachment: note.Attachment?.Checksum,
                generateTitle: !note.Title,
                generateNote: !note.Note,
                generateTranslation: !note.Note,
            })),
        },
        any: () => {
            rs.updateState({ loadingCoverMessage: null });
        },
        no: data => {
            Alerts.Alert({ msg: data.message });
        },
        yes: data => {
            console.log(data);
        },
    });
};
export const generateContent = (rs, note, types) => {
    console.log('TODO: Generate content', rs, note, types);
};
//# sourceMappingURL=generative.js.map